export default "__VITE_ASSET__BqiYHovU__"